import type { RouteObject } from "react-router";

/** Inside the admin layout (sidebar): Online store → Website design. */
export const themeEditorRoutes: RouteObject[] = [
  {
    path: "online-store/themes",
    lazy: async () => ({ Component: (await import("./ThemesListPage")).ThemesListPage }),
  },
  {
    path: "online-store/themes/:themeId/versions",
    lazy: async () => ({ Component: (await import("./publish/VersionsPage")).VersionsPage }),
  },
];

/** Full screen (no admin sidebar): the editor itself (design/03 §5). */
export const themeEditorFullScreenRoutes: RouteObject[] = [
  {
    path: "online-store/themes/:themeId/editor",
    lazy: async () => ({ Component: (await import("./EditorPage")).EditorPage }),
  },
];
